export function getFileExtension(url: string): string {
  if (URL.canParse(url)) {
    const urlObject = new URL(url);
    return urlObject.pathname.split('.').pop() || '';
  } else {
    return url.split('.').pop() || '';
  }
}
